import { render } from "./last-step.vue?vue&type=template&id=26d2bb32"
import script from "./last-step.vue?vue&type=script&lang=js"
export * from "./last-step.vue?vue&type=script&lang=js"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__